import { render, staticRenderFns } from "./Scorekeeper.vue?vue&type=template&id=467dc3f8"
import script from "./Scorekeeper.vue?vue&type=script&lang=ts"
export * from "./Scorekeeper.vue?vue&type=script&lang=ts"
import style0 from "./Scorekeeper.vue?vue&type=style&index=0&id=467dc3f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports